import styles from './SalonManagementList.module.scss';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../routes/constants';
import TitleSectionBack from '../../../Common/TitleSectionBack';
import useWindowSize from '../../../../utils/useWindowSize';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Armchair, ChevronRight, Scissors } from 'lucide-react';

const SalonManagementList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isMobile } = useWindowSize();
  const iconSize = isMobile ? 24 : 22;
  const chevronSize = isMobile ? 22 : 20;

  const salonManagementCardData = [
    {
      key: 'services',
      icon: Scissors,
      title: t('salonManagement.cards.services.title'),
      description: t('salonManagement.cards.services.description'),
      link: `${ROUTES.SALON_MANAGEMENT}${ROUTES.SERVICES}`,
    },
    {
      key: 'chairs',
      icon: Armchair,
      title: t('salonManagement.cards.chairs.title'),
      description: t('salonManagement.cards.chairs.description'),
      link: `${ROUTES.SALON_MANAGEMENT}${ROUTES.WORKERS}`,
    },
  ];

  return (
    <div
      className={clx(styles.salon_management_list_container, {
        [styles.salon_management_list_container_mobile]: isMobile,
      })}
    >
      <div className={styles.header}>
        <TitleSectionBack
          title={t('salonManagement.title')}
          description={t('salonManagement.description')}
          isActiveButton={false}
        />
      </div>
      <div className={styles.list_card}>
        {salonManagementCardData.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.key}
              type="button"
              className={styles.list_item}
              onClick={() => navigate(item.link)}
            >
              <span className={styles.item_icon} aria-hidden="true">
                <Icon size={iconSize} strokeWidth={2.2} />
              </span>
              <span className={styles.item_copy}>
                <span className={styles.item_title}>{item.title}</span>
                <span className={styles.item_description}>{item.description}</span>
              </span>
              <ChevronRight size={chevronSize} strokeWidth={2.2} aria-hidden="true" />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default SalonManagementList;
